<template>
  <div class="page-content-wrapper registration-to-career-list-page" v-check-permission="'list-registration-to-careers'">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card m-b-20">
            <div class="card-block">

              <h4 class="mt-0 header-title">Inscripciones a las carreras</h4>
              <p class="text-muted m-b-30 font-14">Desde aquí puedes gestionar las inscripciones a las carreras.</p>

              <div class="table-rep-plugin">
                <div>
                  <div class="row">
                    <div class="col-md-2 mb-3">
                      <input type="number" @keyup.enter="search()" class="form-control" v-model="params.dni" placeholder="DNI" aria-controls="datatable">
                    </div>
                    <div class="col-md-2 mb-3">
                      <select id="career" class="custom-select form-control" v-model="params.career">
                        <option :value="null">Carrera</option>
                        <option v-for="career in careers" v-bind:value="career._id">
                          {{ career.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-1 mb-3">
                      <select id="level" class="custom-select form-control" v-model="params.level">
                        <option :value="null">Nivel</option>
                        <option v-for="level in levels" v-bind:value="level.value">
                          {{ level.text }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-1 mb-3">
                      <select id="academicYear" class="custom-select form-control" v-model="params.academicYear">
                        <option :value="null">Ciclo lectivo</option>
                        <option v-for="year in years" v-bind:value="year">
                          {{ year }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-1 mb-3">
                      <select id="stateOfRegistrationToCareer" class="custom-select form-control" v-model="params.stateOfRegistrationToCareer">
                        <option :value="null">Estado</option>
                        <option v-for="stateOfRegistrationToCareer in statesOfRegistrationToCareer" v-bind:value="stateOfRegistrationToCareer.value">
                          {{ stateOfRegistrationToCareer.text }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 mb-3">
                      <button class="btn btn-primary bootstrap-touchspin-up" @click="search()" type="button" title="Buscar"><i class="fa fa-search"></i></button>
                      <button class="btn btn-primary" @click="clearFilters()">Limpiar</button>
                      <button class="btn btn-outline-info download" @click="download()" title="Descargar"><i class="fa fa-download" aria-hidden="true"></i></button>
                    </div>
                    <div class="col-md-2 mb-3">
                      <button class="btn btn-primary pull-right" @click="getAll()"><i class="fa fa-refresh" aria-hidden="true"></i> Mostrar todos</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row pull-right mb-2">
                <div class="col-md-12">
                  <small><b>({{ registrationToCareerList.total }} registros)</b></small>
                </div>
              </div>

                <div class="table-responsive b-0" data-pattern="priority-columns">

                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>Usuario</th>
                        <th>Dni</th>
                        <th>Apellido y Nombre</th>
                        <th>Carrera</th>
                        <th>Nivel</th>
                        <th></th>
                        <th>Ciclo lectivo</th>
                        <th>Estado</th>
                        <th style="max-width: 140px;">Observaciones</th>
                        <th>Inscripto el</th>
                        <th class="col-icon"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="registrationToCareerList.docs" v-for="row in registrationToCareerList.docs" :key="row._id">
                        <td v-if="row.user"><b>{{ row.user.email }}</b></td><td v-else></td>
                        <td v-if="row.studentFile">{{ row.studentFile.personalData.dni }}</td><td v-else></td>
                        <td v-if="row.studentFile">{{ row.studentFile.personalData.lastName }} {{ row.studentFile.personalData.firstName }}</td><td v-else></td>
                        <td v-if="row.career">{{ row.career.name }}</td><td v-else></td>
                        <td>{{ row.level }}</td>
                        <td><span class="badge badge-info" v-if="row.repeatingTheClass">Recursante</span></td>
                        <td>{{ row.academicYear }}</td>
                        <td>
                          <span class="badge badge-success" v-if="row.studentRegistrationStatus == 'enrolled-standard'">Matriculado Estándar</span>
                          <span class="badge badge-success" v-if="row.studentRegistrationStatus == 'enrolled-for-exams'">Matrículado para Exámenes</span>
                          <span class="badge badge-success" v-if="row.studentRegistrationStatus == 'enrolled-with-a-scholarship'">Matriculado con Beca</span>
                          <span class="badge badge-danger" v-if="row.studentRegistrationStatus == 'final-approved'">Aprobado Definitivo</span>
                          <span class="badge badge-info" v-if="row.studentRegistrationStatus == 'conditional-approved'">Aprobado Condicional</span>
                          <span class="badge badge-primary" v-if="row.studentRegistrationStatus == 'pending-step-1'">Pendiente (Paso 1 - Sel. de carrera)</span>
                          <span class="badge badge-primary" v-if="row.studentRegistrationStatus == 'pending-step-2'">Pendiente (Paso 2 - Sel. de nivel)</span>
                          <span class="badge badge-primary" v-if="row.studentRegistrationStatus == 'pending-step-3'">Pendiente (Paso 3 - Act. de datos)</span>
                          <span class="badge badge-primary" v-if="row.studentRegistrationStatus == 'pending'">Pendiente</span>
                          <span class="badge badge-dark" v-if="row.studentRegistrationStatus == 'officially-suspended'">Baja Definitiva</span>
                          <span class="badge badge-dark" v-if="row.studentRegistrationStatus == 'suspended-ex-officio'">Baja de Oficio</span>
                        </td>
                        <td style="max-width: 140px;">
                          <small> {{row.observations}} </small>
                        </td>
                        <td>{{ row.createdAt | moment("DD/MM/YYYY") }}</td>
                        <td>
                          <router-link :to="{ name: 'approve-registration-to-careers', params: { id: row._id }}" v-check-permission="'approve-registration-to-careers'" class="text-info mr-3"><i class="fa fa-pencil"></i></router-link>
                          <!--router-link :to="{ name: 'cash-out-registration-fee', params: { id: row._id }}" v-check-permission="'cash-out-registration-fee'" v-if="row.progress.approved.finalApproved || row.progress.approved.conditionalApproved" class="text-info"><i class="fa fa-money"></i></router-link-->
                          <a href="javascript:void(0);" class="text-primary"  @click="setRegistrationToCareer(row)" v-check-permission="'delete-registration-to-career'" data-toggle="modal" data-target="#deleteConfirm"><i class="fa fa-minus-circle"></i></a>
                        </td>
                      </tr>
                      <tr v-if="registrationToCareerList.docs && registrationToCareerList.docs.length === 0">
                        <td colspan="11">No se encontraron registros.</td>
                      </tr>
                    </tbody>
                  </table>

                  <pagination v-bind:current-page="params.page" v-bind:total-pages="registrationToCareerList.pages">
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </div> <!-- end col -->
      </div> <!-- end row -->




      <div id="deleteConfirm" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" v-check-permission="'delete-registration-to-career'">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mt-0">Confirmar eliminación</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p>¿Realmente desea eliminar el registro?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-primary delete-btn" @click="deleteRegistrationToCareer(registrationToCareer._id)">Confirmar</button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
      </div><!-- /.modal -->

    </div><!-- container -->
</template>

<script>
import levels from '../data/levels'
import config from '../data/config'
import statesOfRegistrationToCareer from '../data/statesOfRegistrationToCareer'
import pagination from '../components/Pagination.vue'
import { downloadRegistrationToCareerList } from '../api'

export default {

  name: 'registration-to-careers-list',

  components: {
    pagination
  },

  created(){
    this.getAllCareers();
    this.getAllRegistrationToCareer();

    this.$on('pageChanged:pagination', val => {
      this.params.page = val;
      this.getAllRegistrationToCareer();
    })
  },


  data () {

    return {
      params: {
        limit: config.pagination.limit,
        page: 1,
        dni: null,
        career: null,
        level: null,
        stateOfRegistrationToCareer: null,
        academicYear: null
      },
      levels: levels,
      statesOfRegistrationToCareer: statesOfRegistrationToCareer
    }

  },


  computed: {

    registrationToCareerList: function(){
      return this.$store.getters.getRegistrationToCareerList
    },

    careers: function () {
      return this.$store.getters.getAllCareers
    },

    registrationToCareer: function () {
      return this.$store.getters.getRegistrationToCareer
    },

    years: function () {
      var minYear = 2018;
      var currentYear = (new Date()).getFullYear();
      var years = [];
      var i;

      for (i = minYear; i <= (currentYear + 1); i++) {
        years.push(i);
      }

        return years;
    }

  },


  methods:{

    getAll: function () {
      this.clearFilters();
      this.getAllRegistrationToCareer();
    },


    search: function () {
      if(this.params.dni || this.params.career || this.params.level || this.params.stateOfRegistrationToCareer || this.params.academicYear) {
        this.params.page = 1;
        this.getAllRegistrationToCareer();
      }
    },


  	getAllRegistrationToCareer: function () {
  	  this.$loader.loading();
      this.$store.dispatch('getAllRegistrationToCareer', { params: this.params })
        .then((response) => {
  	      if(!response.success) {
            this.$message.error({text: response.message});
          }
          this.$loader.close();
        })
        .catch(error => {
          this.$loader.close();
          this.$message.error({text: 'Ha ocurrido un error. Intentelo nuevamente mas tarde.'});
        })
    },


    getAllCareers () {
      this.$loader.loading();
      this.$store.dispatch('getAllCareers')
        .then((response) => {
          this.$loader.close();
        })
        .catch((response) => {
          this.$loader.close();
        })
    },


    deleteRegistrationToCareer (id) {
      $('.delete-btn').attr('disabled', true)

      this.$store.dispatch('deleteRegistrationToCareer', { id : id })
        .then((response) => {
          $('.delete-btn').attr('disabled', false)
          $('#deleteConfirm').modal('hide');
        })
        .catch((response) => {
          $('.delete-btn').attr('disabled', false)
          $('#deleteConfirm').modal('hide');
          this.$message.error({text: response.message});
        })

      return true
    },


    setRegistrationToCareer (registrationToCareer) {
      this.$store.dispatch('setRegistrationToCareer', { registrationToCareer : registrationToCareer })
    },


    clearFilters() {
      this.params.dni = null;
      this.params.career = null;
      this.params.level = null;
      this.params.stateOfRegistrationToCareer = null;
      this.params.page = 1;
      this.params.academicYear = null;
    },



    download: function () {

      $('.download').attr('disabled', true);

      downloadRegistrationToCareerList(this.params)
        .then(function (response) {
          let blob = new Blob([response.data], {type: response.headers['content-type']}),
            filename = 'inscriptos_a_carreras.xlsx';
          let result = document.createElement('a');
          result.href = window.URL.createObjectURL(blob);
          result.download = filename;
          result.click();
          $('.download').attr('disabled', false);
        })
        .catch((response) => {
          this.$message.error({text: response.message});
          $('.download').attr('disabled', false);
        })
    }

  }
}
</script>
<style>
	.panel {
    margin-top: 5px;
    margin-bottom: 5px;
    padding: 5px;
  }
  .card {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/RegistrationListToCareersScreen.vue